import * as z from "zod";

import { REQUIRED_MESSAGE, requiredString } from "components/form/utils";

export const referenceObject = () =>
    z
        .object({
            id: requiredString(),
        })
        .or(z.literal(undefined))
        .or(z.literal(null))
        .or(z.literal(""))
        .refine((val) => !!val && !!val.id?.trim(), {
            message: REQUIRED_MESSAGE,
        });

export const openingSchema = z.object({
    title: requiredString(),
    description: z.string().optional().nullable(),
    status: requiredString(),
    sales_coordinator: referenceObject(),
    skills: z.array(requiredString()).min(1, REQUIRED_MESSAGE),
    expertise: requiredString(),
    opportunity_link: z.string().url("Invalid opportunity URL").optional().or(z.literal("")).nullable(),
});
